import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=39629cdc&scoped=true&"
import script from "./TableSettings.vue?vue&type=script&lang=js&"
export * from "./TableSettings.vue?vue&type=script&lang=js&"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=39629cdc&prod&lang=scss&"
import style1 from "./TableSettings.vue?vue&type=style&index=1&id=39629cdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39629cdc",
  null
  
)

export default component.exports